import Vue from "vue";
import Vuex from "vuex";
import data from "@/mock/resume.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: data,
  getters: {
    resume: state => state
  },
  mutations: {},
  actions: {}
});



// WEBPACK FOOTER //
// ./src/store.js